import React, { useState, useEffect } from 'react';
import { Input, Button, Form, Switch } from 'antd';

import { t } from '../../languages';
import { recordPageGA } from '../../modules/ga';
import AgeButtons from '../User/AgeButtons';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';

const JoinClass = ({ lang, onJoin, onCancel, error }) => {
    const [classCode, setClassCode] = useState('');
    const [name, setName] = useState('');
    const [rejoin, setRejoin] = useState(false);
    const [isValid, setIsValid] = useState(false);
    const [errors, setErrors] = useState(null);

    // Registro en Google Analytics
    useEffect(() => {
        recordPageGA('/join-class');
    }, []);

    // Validación en tiempo real
    useEffect(() => {
        setIsValid(classCode.trim().length >= 4 && name.trim().length >= 3);
    }, [classCode, name]);

    const handleCreate = () => {
        if (isValid) {
            onJoin({ classCode: classCode.trim(), name, rejoin });
        }
    };

    return (
        <section className="create-class-form">
            <div className="form-group">

                <Form.Item validateStatus={'error'} help={error && error === 404 ? t(lang, 'incorrectClassCode') : null}>
                    <Input
                        placeholder={t(lang, 'enterClassCode')}
                        value={classCode}
                        onChange={(e) => setClassCode(e.target.value)}
                        autoComplete="off"
                        minLength={4}
                    />
                </Form.Item>

                <Form.Item validateStatus={'error'} help={error && error === 409 ? t(lang, 'studentNameAlreadyExist') : null}>
                    <Input
                        placeholder={t(lang, 'enterYourName')}
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        autoComplete="off"
                        minLength={3}
                    />
                </Form.Item>

                <br />
                <div className='alreadyjoined'>
                    <Switch
                        onChange={(checked) => setRejoin(checked)}
                    /> {t(lang, 'alreadyjoined')} 
                </div>

            </div>

            <br />
            <div className="button-group">
                <Button type="primary" className="button-yellow" onClick={handleCreate} disabled={!isValid}>
                    {t(lang, 'join')}
                </Button>
            </div>
        </section>
    );
};

export default JoinClass;